export enum Event {
  INIT = 'init',
  LOADED = 'loaded',
  ERROR = 'error',
}

export enum Stage {
  CONTAINER_MOUNT = '1.container_mount',
  INNER_LOADED = '2.inner_loaded',
  CONTAINER_ON_READY = '3.container_on_ready',
  CONTAINER_INSTRUCTIONS = '4.container_insturctions',
  INNER_INSTRUCTIONS = '5.inner_instructions',
  UNITY_INSTRUCTIONS = '6.unity_instructions',
}
